import { useSelector } from 'react-redux';
import { getUserInfo } from 'Store/Auth/Auth.selector';
import { ADMIN } from 'Utils/AcessPermission';

// Papéis do tenant que podem alterar o modo de faturamento, as SPEs e os pesos.
// Os demais só visualizam o rateio (item 12268 do épico 12253).
export const RATEIO_EDITOR_ROLES = [ADMIN];

// Lê do userInfo via useSelector, e não do AccessPermission.isAdmin(), para que o
// componente re-renderize quando o userInfo chegar ou o tenant corrente mudar.
export const useCanConfigureRateio = () => {
  const userInfo = useSelector(getUserInfo);

  return {
    canConfigureRateio:
      userInfo?.CurrentRoleFk !== undefined &&
      RATEIO_EDITOR_ROLES.includes(userInfo.CurrentRoleFk),
  };
};
